<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 07: 
                    | Additional information & confirmation
                h3 You are almost done. Just one more step.

        form
            .input-group.required
                label(for="full-name") Full Name
                input(type="text" name="full_name" v-model="fullName" id="full-name" placeholder="your name with initials" required)

            .multiple-group
                .input-group.required
                    label(for="email-address") Email Address
                    input(type="email" name="email" v-model="emailAddress" id="email-address" placeholder="your@domain-name.com" required)

                .input-group.required
                    label(for="contact-number") Contact Number
                    input(type="text" name="contact_number" v-model="contactNumber" id="contact-number" placeholder="+94 000 000 000" required)

            .input-group.textarea-group
                label(for="comments") Comments
                textarea(name="comments" id="comments" v-model="comments" placeholder="Tell us your additional meal requirement & meal preferences")

            .input-group.checkbox-group
                input(type="checkbox" id="transport" v-model="transport" name="transport")
                label(for="transport") Domestic transport required

            .input-group.checkbox-group
                input(type="checkbox" id="airport-pickup" v-model="airportpickup" name="airport-pickup")
                label(for="airport-pickup") Airport pickup/dropoff required                

        .button-row
            a.back(href="" @click.prevent="$router.go(-1)") 
                i.fa.fa-angle-left
                | Back

            a.next(href="" :class="{ active: isActive }" @click.prevent="saveFifthStep") Proceed to checkout                  
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'Confirmation',
        data() {
            return {
                fullName: null,
                emailAddress: null,
                contactNumber: null,
                comments: null,
                transport: 0,
                airportpickup: 0,
                isActive: false,                
            }
        },
        methods: {
            ...mapActions(['postFifthStepBooking']),
            makeActive() {
                if(this.fullName && this.emailAddress && this.contactNumber) {
                    this.isActive = true
                } else {
                    this.isActive = false
                }

                this.transport = (this.transport == true) ? 1 : 0
                this.airportpickup = (this.airportpickup == true) ? 1 : 0
            },
            saveFifthStep() {
                var bookingData = {
                    "id": window.localStorage.getItem('firstStepBookingId'),
                    "name": this.fullName,
                    "email": this.emailAddress,
                    "contact_number": this.contactNumber,
                    "comments": this.comments,
                    "transport_needed": this.transport,
                    "airport_pick_up": this.airportpickup
                };

                this.postFifthStepBooking(bookingData).then(() => {
                    this.$router.push('/checkout');
                });                
            }
        },
        updated() {
            this.makeActive()
        }
    };
</script>

<style lang="sass" scoped>
    form
        margin-bottom: 100px

    @media (max-width: 400px)
        .button-row 
            flex-direction: column
            align-items: flex-start

            .back 
                margin-bottom: 20px

            .next
                width: 100%
                text-align: center
</style>


